import { render, staticRenderFns } from "./LottoWinChart.vue?vue&type=template&id=2f4516c1&scoped=true&lang=pug"
import script from "./LottoWinChart.vue?vue&type=script&lang=js"
export * from "./LottoWinChart.vue?vue&type=script&lang=js"
import style0 from "./LottoWinChart.vue?vue&type=style&index=0&id=2f4516c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4516c1",
  null
  
)

export default component.exports